import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import dayjs from 'dayjs'
import Image from 'next/image'
import { Modal } from 'components/common/modal'
import { SmallText } from 'components/common/text'
import { Column, Row } from 'components/common/layout'
import { getLocalStorage, setLocalStorage } from 'utils/storages'

const JOB_FAIR_BANNER_STORAGE_KEY = 'jobFairBannerHiddenUntil'
const JOB_FAIR_BANNER_END_AT = '2025-11-30T23:59:59+09:00'
const JOB_FAIR_BANNER_URL = 'https://tally.so/r/n020p0'
const JOB_FAIR_HIDE_DAYS = 7
const JOB_FAIR_CLOSE_HIDE_HOURS = 24
const BANNER_ALT = '2026년 스타트업 채용박람회 참가기업 모집'

export const JobFairBannerModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const now = dayjs()
    const hiddenUntil = getLocalStorage<{ expiresAt: number } | null>(
      JOB_FAIR_BANNER_STORAGE_KEY,
      null,
    )
    const isCampaignExpired = now.isAfter(dayjs(JOB_FAIR_BANNER_END_AT))
    const isHiddenForWeek = hiddenUntil?.expiresAt
      ? now.isBefore(dayjs(hiddenUntil.expiresAt))
      : false
    setIsOpen(!isCampaignExpired && !isHiddenForWeek)
  }, [])

  if (!isOpen) return null

  const handleHideForWeek = () => {
    const expiresAt = dayjs().add(JOB_FAIR_HIDE_DAYS, 'day').valueOf()
    setLocalStorage(JOB_FAIR_BANNER_STORAGE_KEY, { expiresAt })
    setIsOpen(false)
  }

  const handleHideForDay = () => {
    const expiresAt = dayjs().add(JOB_FAIR_CLOSE_HIDE_HOURS, 'hour').valueOf()
    setLocalStorage(JOB_FAIR_BANNER_STORAGE_KEY, { expiresAt })
    setIsOpen(false)
  }

  return (
    <Modal
      onClose={() => setIsOpen(false)}
      width={600}
      disableCloseBtn
      disableBackgroundClick
    >
      <BannerCard>
        <BannerLink
          href={JOB_FAIR_BANNER_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          <Image
            src='/job-fair-banner.png'
            alt={BANNER_ALT}
            width={500}
            height={538}
            style={{ width: '100%', height: 'auto' }}
            priority
          />
        </BannerLink>
        <ActionRow>
          <ActionText onClick={handleHideForWeek}>
            일주일간 보지 않기
          </ActionText>
          <ActionText onClick={handleHideForDay}>닫기</ActionText>
        </ActionRow>
      </BannerCard>
    </Modal>
  )
}

const BannerCard = styled(Column)``

const ActionRow = styled(Row)`
  gap: 16px;
  padding: 16px 20px;
  justify-content: flex-end;
  background-color: #080303;
`

const ActionText = styled(SmallText)`
  cursor: pointer;
  text-decoration: underline;
  color: ${(p) => p.theme.color.white1};
  font-weight: ${(p) => p.theme.fontWeight.semiBold};
`

const BannerLink = styled.a``
